export enum FeatureFlags {
  MAINTENANCE = 'maintenance',
  MAINTENANCE_MODE_WARNING = 'maintenance-mode-warning',
}
